module.exports = __webpack_public_path__ + "static/about1-2cb0f56e355b74f5fa00875518317876.svg";